module.exports = __webpack_public_path__ + "img/is.4aa7baad.svg";